<template>
  <!-- :class="{ 'pt-[50]': registerType == 0,'pt-[25]': registerType == 1 }" -->
  <div class="relative px-[50] flex flex-col justify-center  h-[612]"  v-loading="loading">
    <div class="flex justify-between items-center">
      <p class="t-[26] t-[#192530] font-500">快速注册</p>
      <div v-if="supportWxAuth" class="flex overflow-hidden cursor-pointer rounded-[2] leading-[32] text-center">
        <p class="w-[86] t-[14] t-[#606266] border-[#dcdfe6] border-y-[1px] border-l-[1px] border-solid"
          :class="{ '!t-[#fff] !bg-[theme] !border-[theme]': registerType == 0 }" @click="changeRegisterType(0)">微信注册</p>
        <p :class="{ '!t-[#fff] !bg-[theme] !border-[theme]': registerType == 1 }" @click="changeRegisterType(1)"
          class="w-[86] t-[14] t-[#606266] border-[#dcdfe6] border-y-[1px] border-solid border-x-[1px] border-[#dcdfe6] border-solid">手机号注册
        </p>
      </div>
    </div>
    <div :class="{ 'pt-[40]': registerType == 0,'pt-[15]': registerType == 1 }">
      <div v-if="registerType == 0" class="text-center">
        <p class="t-[#303133] t-[20]">微信扫码一键注册</p>
        <template v-if="!loading">
          <div class="relative w-[200] h-[200] mt-[30] mx-[auto]">
            <img class="w-[100%] h-[100%]" :src="qrcode" alt="" />
            <div v-if="status == 2"
              class="bg-[rgb(255,255,255,0.9)] w-[200] h-[200] absolute top-[0] left-[0] bottom-[0] right-[0]">
              <div class="flex h-[200] flex-col items-center justify-center cursor-pointer" @click="getWxAuthQrcode">
                <i class="icon t-[24] t-[#231815]">&#xe6f4;</i>
                <p class="mt-[14] t-[#000000] t-[12]">二维码已失效，点击刷新</p>
              </div>
            </div>
          </div>
          <div class="flex justify-center items-center mt-[30]">
            <img class="h-[18]" src="@/assets/img/public/wx_msg_icon.png" alt="" />
            <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 1">扫码成功</p>
            <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 0">
              请使用微信扫一扫&nbsp;&nbsp;<span class="t-[theme] cursor-pointer" @click="getWxAuthQrcode">刷新</span>
            </p>
            <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 2">
              二维码已失效，<span class="t-[theme] cursor-pointer" @click="getWxAuthQrcode">点击刷新</span>
            </p>
          </div>
          <div class="t-[#909399] t-[14] text-center mt-[12] font-300">扫码注册视您已阅读并同意<a
              href="#/protocolRegister" target="_blank" class="!t-[theme] !no-underline">《注册协议》</a></div>
        </template>
        <template v-else>
          <div class="w-[200] h-[200] mt-[30] mx-[auto]">
            <img class="w-[100%] h-[100%]" :src="getCityAssetsFile('loading_wx_code.png')" alt="" />
          </div>
          <p class="t-[#303133] t-[16] mt-[22]">加载中...</p>
        </template>
      </div>
      <dg-alert-box v-if="registerType == 1">
        <el-form :model="registerForm" ref="registerFormRef" label-width="1px">
          <el-form-item label="" prop="name" :rules="[{ required: true, message: '请填写姓名', trigger: 'blur' }]"
            class="relative mb-[24]">
            <el-input size="large" class="large_input" placeholder="*请填写姓名" v-model="registerForm.name"> </el-input>
          </el-form-item>
          <el-form-item label="" prop="mobile" class="relative mb-[24]" :rules="[
            { required: true, message: '请填写手机号', trigger: 'blur' },
            { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' },
          ]">
            <el-input size="large" class="large_input" placeholder="*请填写手机号" maxlength="11"
              v-model="registerForm.mobile">
            </el-input>
          </el-form-item>
          <div class="relative">
            <el-form-item label="" prop="password" :rules="rules.password" class="relative mb-[24]">
              <el-input class="large_input" size="large" @focus="intensityVisible = true"
                @blur="intensityVisible = false" placeholder="*请设置登录密码" maxlength="32" show-password
                v-model="registerForm.password"> </el-input>
            </el-form-item>
            <dg-pasw-intensity v-show="intensityVisible" :value="registerForm.password"></dg-pasw-intensity>
          </div>
          <el-form-item label="" class="mb-[24]" prop="catchcode"
            :rules="[{ required: true, message: '请输入图形码', trigger: 'blur' }]">
            <div class="flex">
              <div class="relative flex-1 pr-[10]">
                <el-input size="large" class="large_input" placeholder="请输入图形码" v-model="registerForm.catchcode">
                </el-input>
              </div>
              <div class="verificationCode w-[130] pl-[10]" @click="getcaptcha">
                <img :src="verificationCode" class="w-[100%] h-[48]" alt="" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" prop="smsCode" :rules="[{ required: true, message: '请输入短信验证码', trigger: 'blur' }]" class="mb-[16]">
            <div class="relative">
              <el-input size="large" class="large_input" placeholder="请输入短信验证码" v-model="registerForm.smsCode">
                <template v-slot:suffix>
                  <div
                    class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[31] my-[9] t-[theme]"
                    @click="handleSend">{{ CountDownStatus ? "发送短信" : `${CountDownNum}/s` }}</div>
                </template>
              </el-input>
              <div v-show="showPrompt"
                class="absolute bg-[#F0F2F5] h-[22] w-[246] radius-[4] leading-[22] top-[50] right-[0] t-[12] text-center">
                <span class="t-[#303133] zoom-[0.9]">验证码已发送给{{ mobile }}，10分钟内有效</span>
              </div>
            </div>
          </el-form-item>
          <div class="t-[12]"><el-checkbox v-model="isProtocol"></el-checkbox> <span>同意</span> <a
              href="#/protocolRegister" target="_blank" class="!t-[theme]">《用户协议》</a></div>
          <div class="mt-[16]">
            <el-button class="w-[100%]" type="primary" @click="handleregister('registerFormRef')">注册</el-button>
          </div>
        </el-form>
      </dg-alert-box>
      <div :class="{ 'mt-[38]': registerType == 0 }">
        <div v-if="registerType == 0" class="w-[100%] h-[1] bg-[#DFE2E9]"></div>
        <div :class="{ 'mt-[30]': registerType == 0, 'mt-[18]': registerType == 1 }"
          class="text-center cursor-pointer t-[16] t-[#303133]" @click="handleLogin">已有账户，<span
            class="t-[theme]">去登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import { deepCopyRef, encryptDES } from "@/assets/js/utils";
import CountDown from "@/assets/js/countDown";
export default {
  name: "quickRegister",
  mixins: [mixin],
  props: {},
  data() {
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请设置登录密码"));
      } else if (!/^(?!.*(.)\1{2,})(?=.*[a-zA-Z].*[0-9]|[a-zA-Z].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]|[0-9].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]).{6,32}$/.test(value)) {
        callback(new Error("设置密码格式错误"));
      } else {
        callback();
      }
    };
    return {
      registerType: 0,
      CountDownNum: 60,
      intensityVisible: true,
      CountDownStatus: true,
      isProtocol: true,
      verificationCode: "",
      registerForm: {
        mobile: "", // 手机号
        name: "", // 姓名
        catchcode: "", // 图像吗
        password: "", // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        smsCode: "", // 短信验证码
        saleName: "", // 分销员名称
        saleUserId: "", // 分销员用户ID
      },
      mobile: "",
      countDown: {},
      showPrompt: false,
      rules: {
        password: [{ required: true, validator: password }],
      },
      supportWxAuth: false,
      authcode: "",
      qrcode: "",
      loading: true,
      timer: null,
      status: 0, // 0 等待扫码， 1 扫码成功， 2 扫码失败
    };
  },
  methods: {
    // 跳转登录
    handleLogin() {
      this.$emit("changeToLogin");
    },
    // 切换注册类型
    changeRegisterType(t) {
      Mirror.emit("tips_el_alert_box_close");
      this.$refs["registerFormRef"] && this.$refs["registerFormRef"].clearValidate();
      this.registerType = t;
      if (t == 1) {
        this.timer && clearInterval(this.timer);
      }
      if (t == 0) {
        this.getIsSupportWxAuth();
      }
    },

    /**
     * @author 伟健 / 张
     * @name 注册
     * @param
     * @return
     */
    handleregister(formName) {
      if (!this.isProtocol) {
        Mirror.emit('tips_bus', {
          msg: "请同意协议",
          type: "warning",
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _registerForm = deepCopyRef(this.registerForm);
          _registerForm.password = encryptDES(_registerForm.password);
          ajax.post({
            url: "/customer/auth/personRegist",
            data: _registerForm,
            self: this,
            success: (res) => {
              if (res) {
                Mirror.emit('tips_bus', {
                  msg: "注册成功",
                  type: "success",
                });
                setTimeout(() => {
                  // this.push({ path: "/login" });
                  this.handleLogin();
                }, 1500);
              }
            },
          });
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name 发送短信
     * @param
     * @return
     */
    handleSend() {
      this.showPrompt = false;
      Mirror.emit("tips_el_alert_box_close");
      if (!this.countDown.checkStatus()) {
        return;
      }

      let hasError = false;
      this.$refs["registerFormRef"].validateField(["mobile", "catchcode"], (err) => {
        if (err) {
          hasError = true;
          return;
        }
      });
      if (!hasError) {
        ajax.post({
          url: "/customer/common/sendSmsCode",
          self: this,
          data: {
            catchcode: this.registerForm.catchcode, // 图形验证码
            mobile: this.registerForm.mobile, // 手机号码
          },
          success: (res) => {
            this.showPrompt = true;
            if (res) {
              this.countDown.start();
              this.mobile = this.registerForm.mobile;
            }
          },
          fail: () => {
            this.getcaptcha();
          },
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 倒计时
     * @param
     * @return
     */
    handleCountDown() {
      this.countDown.start();
    },
    /**
     * @author 伟健 / 张
     * @name 获取图像码
     * @param
     * @return
     */
    getcaptcha() {
      ajax.post({
        url: "/customer/common/getcaptcha",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.verificationCode = res;
          }
        },
      });
    },
    // 获取是否支持微信小程序授权验证手机号
    getIsSupportWxAuth() {
      this.loading = true;
      ajax.post({
        url: "/customer/common/supportWxappletMobileAuthQrcode",
        data: {},
        self: this,
        success: (res) => {
          this.loading = false;
          if (res) {
            this.supportWxAuth = res.support;
            this.registerType = this.supportWxAuth ? 0 : 1;
            if (this.supportWxAuth) {
              this.getWxAuthQrcode();
            }
          }
        }, fail: () => {
          this.loading = false;
        },
      });
    },
    getWxAuthQrcode() {
      this.loading = true;
      this.authcode = "";
      ajax.post({
        url: "/customer/common/createWxappletMobileAuthQrcode",
        data: {},
        self: this,
        success: (res) => {
          this.loading = false;
          if (res) {
            this.authcode = res.authcode;
            this.qrcode = res.qrcode;
            this.status = 0;
            this.handleStartQueryWxAuthQrCodeStatus();
          }
        },
        fail: (err) => {
          this.loading = false;
          console.log("err", err);
        },
      });
    },
    // 获取微信扫码状态
    getWxAuthQrcodeStatus() {
      if (!this.authcode) return;
      ajax.post({
        url: "/customer/auth/scanQrcodeWxappletMobileAuthLoginOrRegist",
        data: { authCode: this.authcode },
        self: this,
        success: (res) => {
          this.status = res.result;
          if (this.status == 1) {
            this.getCurrent();
          }
        },
        fail: (err) => {
          console.log("err", err);
        },
      });
    },
    /**
     * @author 伟健 / 张
     * @name 用户信息
     */
    getCurrent() {
      ajax.post({
        url: "/customer/user/current",
        data: {},
        self: this,
        success: (res) => {
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            if(this.$route.query.type == "loanApply"){
              this.push({ path: "/loan/apply" });
            }else{
              this.push({ path: "/" });
            }
          }
        },
      });
    },
    // 开始查询微信扫码状态
    handleStartQueryWxAuthQrCodeStatus() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        this.getWxAuthQrcodeStatus();
      }, 3000);
    },
  },
  created() {
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "register",
    });
    this.getcaptcha();
    this.getIsSupportWxAuth();
    this.registerForm.saleName = this.$route.query.saleUserName || "";
    this.registerForm.saleUserId = this.$route.query.saleUserId || "";
  },
  mounted() { },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.timer = null;
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.font-300 {
  font-weight: 300;
}

</style>
